// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__AgegL","list":"styles_list__nYdiw","inline":"styles_inline__YQuQT"};